var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("nos-loading", { ref: "nppfs-loading" }),
      _c(
        "div",
        {
          staticClass: "nppfs-keypad-div",
          staticStyle: { position: "relative" }
        },
        _vm._l(_vm.components, function(item) {
          return _c(
            item.component,
            _vm._g(
              _vm._b(
                {
                  key: item.id,
                  ref: item.ref,
                  refInFor: true,
                  tag: "component",
                  on: { update: _vm.update }
                },
                "component",
                item.props,
                false
              ),
              item.events
            )
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }